import React from 'react';
import { Box } from '@mui/material';

const BibleLogo = () => (
  <Box display="flex" justifyContent="center" alignItems="center" mb={4}>
    <img
      src={process.env.PUBLIC_URL + '/App Icon.png'}
      alt="App Logo"
      style={{ width: 64, height: 64, borderRadius: 16, boxShadow: '0 2px 8px #1976d244' }}
    />
  </Box>
);

export default BibleLogo; 